import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const PMInstructionsEditor: React.FC<Props> = ({ mode }) => {
  const { pmInstructions, updatePMField } = usePMDetailsEditor(mode);

  const handleChange = (value: string) => {
    updatePMField({ instructions: value });
  };

  return (
    <TextField
      label="PM Instructions"
      value={pmInstructions || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      multiline
      minRows={2}
      maxRows={4}
      placeholder="Enter preventive maintenance instructions"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <DescriptionOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PMInstructionsEditor;
